import { oc } from '@orpc/contract';
import { createTemplateDraftVersionInputSchema, templateVersionSchema } from '../schemas/templates.schemas.js';
/** Opens a draft from the published version. When a draft already exists it is handed back unchanged. */
export const createTemplateDraftVersionContract = oc
    .route({
    method: 'POST',
    path: '/templates/{templateId}/draft',
    tags: ['Templates'],
    summary: 'Open a draft version of the template',
})
    .input(createTemplateDraftVersionInputSchema)
    .output(templateVersionSchema);
//# sourceMappingURL=create-template-draft-version.contract.js.map